<template>
  <div class="localization">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-12">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <!-- {{profileArr}} -->
                  <div class="col-sm-12">
                    <h3 class="page-title">Petunjuk Penggunaan</h3>
                  </div>
                </div>
              </div>

              <div class="row row-sm">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <!-- <PDFViewer
                    :source="'https://s3-id-jkt-1.kilatstorage.id/cdn.waajo.id/manual-book/WAAJO-ManualBook-v1.pdf'"
                    style="height: 100vh; width: 100vw" /> -->
                <div class="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3 text-center">
                  <a :href="manualbook" target="_blank" class=" " >Klik disini untuk melihat</a>
                </div>
                </div>
              </div>
              <br />
              <br />
              <br />
              <h4>Tutorial Lainnya</h4>

              <div class="row row-sm">

                <div class="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3">
                  <div class="card card-file">
                    <div class="text-center">
                      <a href="https://www.youtube.com/watch?v=R8SWkfdspB0" target="_blank"> <img
                          :src="'https://i3.ytimg.com/vi/R8SWkfdspB0/hqdefault.jpg'" :style="'width:80%;'" />
                        <br /><span>Cara membuat lisensi di Waajo</span> </a>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3">
                  <div class="card card-file">
                    <div class="text-center">
                      <a href="https://www.youtube.com/watch?v=OyUUGTZVLKE" target="_blank"> <img
                          :src="'http://i3.ytimg.com/vi/OyUUGTZVLKE/hqdefault.jpg'" :style="'width:80%;'" />
                        <br /><span>Cara sinkron kontak Whatsapp</span> </a>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3">
                  <div class="card card-file">
                    <div class="text-center">
                      <a href="https://s3-id-jkt-1.kilatstorage.id/cdn.waajo.id/manual-book/WAAJO-ManualBook-v1.pdf"
                        target="_blank"> <img
                          :src="'https://s3-id-jkt-1.kilatstorage.id/cdn.waajo.id/manual-book/cover-v2.png'"
                          :style="'width:80%;'" />
                      </a>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
// import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
import LayoutSidebarPromotion from "@/components/layouts/Sidebar.vue";

// import VueSimpleAlert from "vue-simple-alert";
// import { downloadImage } from "@/utils/helper";
import QrcodeVue from "qrcode.vue";
// import PDFViewer from 'pdf-viewer-vue'
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'


export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion,
    QrcodeVue,
    PDFViewer
  },
  computed: {
    // memberSession() {
    //   return this.$store.state.login.memberSession;
    // },
    // isJoinAffiliate() {
    //   return this.$store.state.referral.isJoin;
    // }
  },
  data() {
    return {
      appTitle: process.env.VUE_APP_TITLE,
      manualbook:process.env.VUE_APP_LINK_DOCS_WAAJO,
      isLoading: false,
      isLoadingImages: false,
      isLoadingInfo: false,
      referralLink: "",
      imgArr: [],
      infoArr: {
        id: 0,
        referral_code: "",
        referral_join_datetime: 0,
        referral_bonus: 0,
        target_omzet: 0,
        update_datetime: 0
      }
    };
  },
  async created() {
    // this.info();
    //this.shareLink();
    // this.images();
    // if (this.isJoinAffiliate == false) {
    //   this.$router.push({ path: "/referral" });
    // }
  },
  mounted(){  
    setTimeout(() => {
      window.open(process.env.VUE_APP_LINK_DOCS_WAAJO, '_blank');
    }, 500);
  },
  methods: {
    images() {
      this.isLoadingImages = true;
      this.$store
        .dispatch("referral/images")
        .then(response => {
          this.isLoadingImages = false;
          this.imgArr = response.data;
        })
        .catch(() => {
          this.isLoadingImages = false;
        });
    },

  }, 
  name: "manual-book"
};
</script>


// WEBPACK FOOTER //
// src/views/page/manualbook.vue